const CROPPER_SHAPES = {
  ROUND: 'round',
  RECT: 'rect',
}

export default CROPPER_SHAPES
